import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2024 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : transcription activity
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { Actions } from 'uix/registries';
import log from 'uix/logging';
import { useApi } from 'uix/hooks';
// ---Local imports
import { TranscriptionLayout, BasicButton } from '../components';
import { useApiWithPuid } from '../hooks';
// ---Exports
export const TranscriptionActivity = ({ i18n })=>{
    let { data } = useApiWithPuid('filter/getTranscriptionActivities');
    let activeItems = data?.transcriberActivity.activeItems || [];
    let activity = 'No activity recorded';
    let translateState = (state)=>{
        let s = {
            6: 'toresume',
            4: 'released',
            3: 'torelease',
            1: 'tocheck'
        }[state];
        return i18n.span(`tr_state_${s}`);
    };
    if (activeItems.length !== 0) {
        activity = activeItems.map(({ otid, caption, activePages })=>{
            let pages = activePages.map((page)=>/*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx("td", {
                            children: page.caption
                        }),
                        /*#__PURE__*/ _jsx("td", {
                            children: page.ts
                        }),
                        /*#__PURE__*/ _jsx("td", {
                            children: translateState(page.state)
                        }),
                        /*#__PURE__*/ _jsxs("td", {
                            children: [
                                /*#__PURE__*/ _jsx(BasicButton, {
                                    icon: "edit",
                                    link: {
                                        tabname: 'wiki',
                                        id: page.otid
                                    }
                                }),
                                /*#__PURE__*/ _jsx(BasicButton, {
                                    icon: "check",
                                    onClick: ()=>'/bau/action/setCheckpoint?otid=2048820'
                                }),
                                /*#__PURE__*/ _jsx(BasicButton, {
                                    icon: "eye",
                                    onClick: ()=>'/bau/content/pagetext/2048820'
                                })
                            ]
                        })
                    ]
                }, page.otid));
            return /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        children: caption
                    }),
                    /*#__PURE__*/ _jsxs("table", {
                        children: [
                            /*#__PURE__*/ _jsx("thead", {
                                children: /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            children: i18n.span('page')
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            children: i18n.span('lastModifiedDate')
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            children: i18n.span('state')
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            children: i18n.span('action')
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("tbody", {
                                children: pages
                            })
                        ]
                    })
                ]
            }, otid);
        });
    }
    return /*#__PURE__*/ _jsx(TranscriptionLayout, {
        children: activity
    });
};
